import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './main/App';

const root = document.getElementById('app');

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.REACT_APP_SUBPATH}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  root,
);
